module.exports = __webpack_public_path__ + "static/media/Whispering-Meadows-Covenants.ce52f728.pdf";